import { useEffect, useState, useRef } from 'react'

export const OtpFieldsNew = ({
  numberOfFields = 4,
  onChange = () => {},
  inputClassName = 'focus:border-primary border-[#E5E5E6] w-[40px] h-[40px]',
  containerClassName = 'space-x-[14.39px]',
  disabled = false,
  clearData = false,
  setOtpError,
  ...rest
}) => {
  const [fildsData, setFilds] = useState([])
  const [otp, setOtp] = useState('')

  const inputRef = useRef()

  useEffect(() => {
    inputRef.current.focus()
  }, [])

  const setInitialValues = () => {
    let temp = []
    for (let index = 0; index < numberOfFields; index++) {
      temp.push('')
    }
    // @ts-ignore
    setFilds([...temp])
  }

  useEffect(() => {
    const fetchOTP = async () => {
      if (!navigator.credentials || !navigator.credentials.get) {
        console.warn('Credentials API not supported.');
        return;
      }
  
      const isOtpSupported = (() => {
        try {
          navigator.credentials.get({ otp: { transport: ['sms'] } });
          return true;
        } catch (e) {
          return false;
        }
      })();
  
      if (!isOtpSupported) {
        console.warn('Web OTP API is not supported in this browser.');
        return;
      }
  
      try {
        const ac = new AbortController();
  
        // Abort after 10 minutes
        const timeoutId = setTimeout(() => {
          ac.abort();
        }, 10 * 60 * 1000);
  
        const otpCredential = await navigator.credentials.get({
          otp: { transport: ['sms'] },
          signal: ac.signal
        });
  
        clearTimeout(timeoutId);
  
        if (otpCredential && otpCredential.code) {
          setOtp(otpCredential.code);
          setFilds(otpCredential.code.split(''));
        }
      } catch (err) {
        if (err.name === 'AbortError') {
          console.log('OTP retrieval timed out.');
        } else {
          console.error('Error retrieving OTP:', err);
        }
      }
    };
  
    fetchOTP();
  }, []);

  useEffect(() => {
    setInitialValues()
  }, [numberOfFields])

  useEffect(() => {
    if (fildsData?.length != numberOfFields) {
      setInitialValues()
    }
    if (fildsData?.join('')?.trim()?.length <= 0) {
      fildsData.map((item, index) => {
        // @ts-ignore
        if (index != 0) document?.getElementById(index)?.setAttribute?.('disabled', 'disabled')
      })
      // @ts-ignore
      document?.getElementById?.(0)?.removeAttribute('disabled')
    }
    onChange((fildsData || []).join(''))
  }, [fildsData])

  useEffect(() => {
    if (clearData) setInitialValues()
  }, [clearData])

  useEffect(() => {
    if (otp) {
      // @ts-ignore
      setFilds(otp?.split(''))
    }
  }, [otp])

  return (
    <div className="mr-[24px]">
      <input
        className="font-black flex h-[48px] rounded-xs border-[1px] border-solid border-[#E5E5E5] bg-[white] px-[12px] text-md font-[500] leading-[25.2px] text-darkGray focus:outline-none"
        type="tel"
        inputMode="numeric"
        ref={inputRef}
        maxLength={4}
        name="one-time-code"
        autoComplete="one-time-code"
        onChange={(e) => {
          const numericValue = e.target.value.replace(/[^0-9]/g, '')
          setOtp(numericValue)
        }}
        onPaste={(event) => {
          const digits = event.clipboardData.getData(event.clipboardData.types[0])?.slice(0, 4)
          setOtp(digits)
        }}
        value={otp}
      />
    </div>
  )
}